import { tw } from 'twind'
import { useEffect } from 'react'
import globalStyles from './globalStyles'
import setupTheme from './setupTheme'

setupTheme()

export type ThemeType = {
  colors?: {
    'primary-01'?: string
    'primary-02'?: string
    'primary-03'?: string

    'secondary-01'?: string
    'secondary-02'?: string
    'secondary-03'?: string

    'tertiary-01'?: string
    'tertiary-02'?: string

    'brand-01'?: string
    'brand-02'?: string
    'brand-03'?: string

    'background-01'?: string
    'background-02'?: string
    'background-03'?: string

    'neutral-01'?: string
    'neutral-02'?: string
    'neutral-03'?: string
    'neutral-04'?: string
    'neutral-05'?: string
    'neutral-06'?: string
    'neutral-07'?: string
    'neutral-08'?: string
    'neutral-09'?: string

    'success-01'?: string
    'success-02'?: string

    'info-01'?: string
    'info-02'?: string

    'error-01'?: string
    'error-02'?: string

    'warning-01'?: string
    'warning-02'?: string

    'support-01'?: string
    'support-02'?: string
    'support-03'?: string
    'support-04'?: string
    'support-05'?: string
    'support-06'?: string
    'support-07'?: string
    'support-08'?: string
    'support-09'?: string
    'support-10'?: string
    'support-11'?: string
    'support-12'?: string
    'support-13'?: string
    'support-14'?: string
    'support-15'?: string
    'support-16'?: string
    'support-17'?: string
    'support-18'?: string
    'support-19'?: string
    'support-20'?: string
    'support-21'?: string
    'support-22'?: string
    'support-23'?: string
    'support-24'?: string
    'support-25'?: string
    'support-26'?: string
    'support-27'?: string
    'support-28'?: string
    'support-29'?: string

    'disabled-01'?: string
    'disabled-02'?: string
    'disabled-03'?: string
    'disabled-04'?: string
  }
}

interface ThemeProviderProps {
  theme?: ThemeType
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme }) => {
  useEffect(() => {
    tw(globalStyles(theme))
  }, [])

  return <>{children}</>
}

export { ThemeProvider }
